export const pastShiftTabs = ['shift', 'volunteers'];
export const defaultPastShiftTab = 'shift';
